// utils/formatNumber.js

/**
 * Format number based on timezone.
 * - Uses Lakh/Cr if timezone is 'Asia/Kolkata'
 * - Uses K/M/B for other timezones
 */

const formatNumber = (num, timezone = "UTC") => {
  if (num === null || num === undefined) return "0";
  const number = Number(num);
  const isIndianTimezone = timezone === "Asia/Kolkata";

  if (isIndianTimezone) {
    if (number >= 1e7) {
      return (number / 1e7).toFixed(1) + " Cr";
    } else if (number >= 1e5) {
      return (number / 1e5).toFixed(1) + " L";
    } else {
      return number;
    }
  } else {
    if (number >= 1_000_000_000) {
      return (number / 1_000_000_000).toFixed(1) + "B";
    } else if (number >= 1_000_000) {
      return (number / 1_000_000).toFixed(1) + "M";
    } else if (number >= 1_000) {
      return (number / 1_000).toFixed(1) + "K";
    } else {
      return number;
    }
  }
};

export default formatNumber;
